(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bugmd-presell-reasons"] && !Shopify.designMode) return;
  try {
    
/* Lazy-load reason videos — defer fetch until 200px from viewport.
   Falls back to animated AVIF on iOS Low Power Mode (NotAllowedError). */
(function () {
  var videos = document.querySelectorAll('.presell-reasons video.lazy-video');
  if (!videos.length) return;
  var io;

  function swapToAnimatedImage(v) {
    if (v.dataset.swapped) return;
    v.dataset.swapped = '1';
    if (io) io.unobserve(v);
    var img = document.createElement('img');
    img.className = 'lazy-video';
    img.src = v.dataset.poster || v.poster || '';
    img.alt = 'Product demo ' + v.dataset.reason;
    img.width = 600;
    img.height = 600;
    img.decoding = 'async';
    img.style.objectFit = 'cover';
    v.parentNode.replaceChild(img, v);
  }

  function activate(v) {
    if (v.dataset.swapped) return;
    if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function (err) {
        if (err && err.name === 'NotAllowedError') swapToAnimatedImage(v);
      });
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(activate);
    return;
  }

  io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) activate(v);
      else { try { v.pause(); } catch (e) {} }
    });
  }, { rootMargin: '200px 0px' });

  videos.forEach(function (v) { io.observe(v); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bugmd-presell-sale-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var banner = document.getElementById('presell-sale-banner');
  if (!banner) return;

  var KEY = 'presellCountdownEnd';
  var hrs = parseInt(banner.dataset.cdHours || '2', 10);
  var min = parseInt(banner.dataset.cdMinutes || '12', 10);
  var DURATION_MS = (hrs * 3600 + min * 60) * 1000;

  var endAt = parseInt(localStorage.getItem(KEY) || '0', 10);
  var now = Date.now();
  if (!endAt || endAt <= now) {
    endAt = now + DURATION_MS;
    localStorage.setItem(KEY, String(endAt));
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var diff = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    var hEl = document.getElementById('cu-hrs');
    var mEl = document.getElementById('cu-min');
    var sEl = document.getElementById('cu-sec');
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k9-shop-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Accessory add-to-cart. The dissolver never reaches this, because its
       block is set to "Go to product page" so the plan picker and the Kaching
       bundle payload stay in charge of that product. */

    function openCart() {
      /* UpCart exposes an opener once it has booted. Names have varied between
         versions, so try the known ones before falling back to a refresh. */
      var openers = ['upcartOpenCart', 'upcartToggleCart', 'upcartShowCart'];
      for (var i = 0; i < openers.length; i++) {
        if (typeof window[openers[i]] === 'function') { window[openers[i]](); return true; }
      }
      if (typeof window.upcartRefreshCart === 'function') { window.upcartRefreshCart(); }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return false;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-k9-add]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      var idle = btn.getAttribute('data-idle-label') || 'Add';
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) { throw new Error(d.description || d.message || 'Could not add to cart.'); }
          return d;
        });
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = 'Added';
        openCart();
        setTimeout(function () { btn.textContent = idle; }, 1600);
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.textContent = idle;
        if (window.console && console.error) {
          console.error('[K9 shop] add to cart failed:', err.message);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k9-sub-faq"] && !Shopify.designMode) return;
  try {
    
  /* Accordion behaviour for K9 Sub - FAQ.
     Two jobs: animate the open/close, and keep only one question open.
     Without this file the markup is still a plain <details> list, which opens
     and closes correctly, just instantly and without the one-at-a-time rule. */
  (function () {
    var DUR = 280;

    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function openItem(item, wrap) {
      item.classList.add('is-open');
      item.open = true;
      if (reduced()) { wrap.style.height = 'auto'; return; }
      wrap.style.height = '0px';
      wrap.offsetHeight;                                  // force a reflow so the 0 sticks
      wrap.style.height = wrap.scrollHeight + 'px';
      window.setTimeout(function () {
        if (item.classList.contains('is-open')) wrap.style.height = 'auto';
      }, DUR);
    }

    function closeItem(item, wrap) {
      item.classList.remove('is-open');
      if (reduced()) { item.open = false; wrap.style.height = ''; return; }
      wrap.style.height = wrap.scrollHeight + 'px';
      wrap.offsetHeight;
      wrap.style.height = '0px';
      window.setTimeout(function () {
        if (!item.classList.contains('is-open')) { item.open = false; wrap.style.height = ''; }
      }, DUR);
    }

    function init(root) {
      var list = root.querySelector('.k9faq');
      if (!list || list.dataset.k9faqReady) return;
      list.dataset.k9faqReady = '1';
      list.classList.add('k9faq--js');

      var items = Array.prototype.slice.call(list.querySelectorAll('.k9faq__item'));
      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        var wrap = item.querySelector('.k9faq__a-wrap');
        if (!summary || !wrap) return;

        if (item.open) { item.classList.add('is-open'); wrap.style.height = 'auto'; }
        else { wrap.style.height = '0px'; }

        summary.addEventListener('click', function (e) {
          e.preventDefault();                             // we drive `open` ourselves
          if (item.classList.contains('is-open')) {
            closeItem(item, wrap);
          } else {
            items.forEach(function (other) {
              if (other !== item && other.classList.contains('is-open')) {
                closeItem(other, other.querySelector('.k9faq__a-wrap'));
              }
            });
            openItem(item, wrap);
          }
        });
      });
    }

    function boot() {
      document.querySelectorAll('.k9sub--faq').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // the theme editor re-renders sections in place
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) e.target.querySelectorAll('.k9sub--faq').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Scope each FAQ section independently so multiple FAQs on one page
       don't control each other's open/close state. */
    var sections = document.querySelectorAll('.petlab-faq[data-section-id]');

    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('.petlab-faq__trigger');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var contentId = this.getAttribute('aria-controls');
          var content = document.getElementById(contentId);

          /* Close all other items WITHIN THIS SECTION only */
          triggers.forEach(function(otherTrigger) {
            if (otherTrigger !== trigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              var otherId = otherTrigger.getAttribute('aria-controls');
              var otherContent = document.getElementById(otherId);
              if (otherContent) {
                otherContent.style.maxHeight = '0';
                otherContent.classList.remove('petlab-faq__content--open');
              }
            }
          });

          /* Toggle current */
          if (expanded) {
            this.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
            content.classList.remove('petlab-faq__content--open');
          } else {
            this.setAttribute('aria-expanded', 'true');
            /* Use scrollHeight but also set to 'none' after transition so
               dynamically-grown content (images loading, etc.) stays visible */
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('petlab-faq__content--open');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-info-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.petlab-info-accordion');
    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          var contentId = trigger.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          if (!content) return;
          if (expanded) {
            trigger.setAttribute('aria-expanded', 'false');
            content.setAttribute('hidden', '');
          } else {
            trigger.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[id^="petlab-carousel-"]');

    carousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-slides]');
      var dotsContainer = carousel.querySelector('[data-dots]');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');

      if (!slidesContainer) return;

      var slides = slidesContainer.querySelectorAll('.petlab-carousel__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      var currentSlide = 0;

      function goToSlide(index) {
        currentSlide = index;
        /* Use the slide's own offsetLeft so the gap between slides is
           automatically accounted for — no manual math needed. */
        var targetSlide = slides[index];
        if (targetSlide) {
          slidesContainer.style.transform = 'translateX(-' + targetSlide.offsetLeft + 'px)';
        }
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.petlab-carousel__dot');
          dots.forEach(function(d, i) {
            d.classList.toggle('petlab-carousel__dot--active', i === index);
          });
        }
      }

      /* Build dots (only if more than 1 slide) */
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-carousel__dot' + (index === 0 ? ' petlab-carousel__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide((currentSlide + 1) % totalSlides);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector-pdp-SANDBOX"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab2-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp2-carousel-slides]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab2-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var currentSlide = 0;
      var progressFill = carousel.querySelector('[data-pdp2-carousel-progress-fill]');
      var thumbButtons = carousel.querySelectorAll('.petlab2-pdp__carousel-thumb');
      var thumbsContainer = carousel.querySelector('[data-pdp2-carousel-thumbs]');
      var thumbPrev = carousel.querySelector('[data-pdp2-thumb-prev]');
      var thumbNext = carousel.querySelector('[data-pdp2-thumb-next]');
      var desktopMq = window.matchMedia('(min-width: 768px)');

      /* Desktop: navigate main image via translateX */
      var thumbOffset = 0;
      var thumbsPerView = 4;

      function updateThumbView() {
        if (!thumbsContainer) return;
        var thumbEls = thumbsContainer.querySelectorAll('.petlab2-pdp__carousel-thumb');
        if (thumbEls.length === 0) return;
        var thumbWidth = thumbEls[0].offsetWidth + 6;
        thumbsContainer.scrollTo({ left: thumbOffset * thumbWidth, behavior: 'smooth' });
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentSlide = index;
        slidesContainer.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        thumbButtons.forEach(function(thumb, i) {
          thumb.classList.toggle('petlab2-pdp__carousel-thumb--active', i === index);
        });
        /* Keep active thumb in the visible window of 4 */
        if (index < thumbOffset) {
          thumbOffset = index;
          updateThumbView();
        } else if (index >= thumbOffset + thumbsPerView) {
          thumbOffset = index - thumbsPerView + 1;
          updateThumbView();
        }
      }

      /* Thumbnail click handlers */
      thumbButtons.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { goToSlide(i); });
      });

      /* Thumbnail strip arrow handlers — shift visible thumbnails + navigate main image */
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function() {
          if (thumbOffset > 0) {
            thumbOffset--;
            updateThumbView();
          }
          if (currentSlide > 0) goToSlide(currentSlide - 1);
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function() {
          if (thumbOffset < totalSlides - thumbsPerView) {
            thumbOffset++;
            updateThumbView();
          }
          if (currentSlide < totalSlides - 1) goToSlide(currentSlide + 1);
        });
      }

      /* Mobile: progress bar — smooth RAF loop */
            /* Mobile: progress bar — updates only when the carousel is swiped */
      if (progressFill) {
        var progressTicking = false;
        var updateProgress = function() {
          progressTicking = false;
          if (desktopMq.matches) return;
          var sw = slidesContainer.scrollWidth;
          var cw = slidesContainer.clientWidth;
          if (sw > cw) {
            var p = (slidesContainer.scrollLeft + cw) / sw;
            progressFill.style.width = (Math.min(Math.max(p, 0), 1) * 100) + '%';
          }
        };
        slidesContainer.addEventListener('scroll', function() {
          if (!progressTicking) {
            progressTicking = true;
            requestAnimationFrame(updateProgress);
          }
        }, { passive: true });
        window.addEventListener('resize', updateProgress);
        window.addEventListener('load', updateProgress);
        updateProgress();
      }

      /* Handle resize between mobile ↔ desktop */
      function handleResize() {
        if (desktopMq.matches) {
          slidesContainer.scrollLeft = 0;
          goToSlide(currentSlide);
        } else {
          slidesContainer.style.transform = '';
        }
      }
      if (desktopMq.addEventListener) { desktopMq.addEventListener('change', handleResize); }
      else if (desktopMq.addListener) { desktopMq.addListener(handleResize); }

      /* Desktop: swipe on main image */
      var deskTouchStartX = 0;
      slidesContainer.addEventListener('touchstart', function(e) {
        if (desktopMq.matches) deskTouchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slidesContainer.addEventListener('touchend', function(e) {
        if (!desktopMq.matches) return;
        var diff = deskTouchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide(currentSlide + 1);
          else goToSlide(currentSlide - 1);
        }
      });

      /* Initial state */
      if (desktopMq.matches) { goToSlide(0); }
    });

    /* ============ REMOVED: size button handlers ============
       The dog-size selector no longer exists. The old
       sizeIndexToQuantity bridge and its auto-click are gone;
       the default plan is now selected directly (see below). */

    var infoWrapper = document.getElementById('petlab2-pdp-info');
    var sellingPlanInput = document.getElementById('petlab2-selling-plan');
    var quantityInput = document.getElementById('petlab2-line-quantity');
    var variantInputEl = document.getElementById('petlab2-variant-id');
    var atcPriceSlot = document.querySelector('[data-atc-price-slot]');

    /* Gift variants in tile order; a blank entry is a display-only tile */
    var kitVariants = (infoWrapper ? (infoWrapper.getAttribute('data-kit-variants') || '') : '')
      .split(',')
      .map(function(v) { return (v || '').trim(); });

    /* ============ Purchase type ============
       CHANGED: the selling plan is no longer a single section-level value, so
       this only flags the mode on the wrapper (the CSS uses it to hide
       subscription-only elements). selectCard() sets the plan itself. */
    function setPurchaseType(type) {
      if (!infoWrapper) return;
      infoWrapper.setAttribute('data-purchase-type', type);
    }

    /* ============ Plan card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab2-pdp__qty-card');

    function selectCard(card) {
      qtyCards.forEach(function(c) {
        c.classList.remove('petlab2-pdp__qty-card--selected');
        c.setAttribute('aria-checked', 'false');
        var r = c.querySelector('.petlab2-pdp__radio-outer');
        if (r) { r.classList.remove('petlab2-pdp__radio-outer--checked'); r.innerHTML = ''; }
      });
      card.classList.add('petlab2-pdp__qty-card--selected');
      card.setAttribute('aria-checked', 'true');
      var radio = card.querySelector('.petlab2-pdp__radio-outer');
      if (radio) { radio.classList.add('petlab2-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab2-pdp__radio-inner"></div>'; }

      var isOneTime = card.getAttribute('data-purchase-mode') === 'onetime';

      /* CHANGED: variant, selling plan and quantity all come from the card now.
         Each supply length is its own variant, so quantity is normally 1. */
      if (variantInputEl) variantInputEl.value = card.getAttribute('data-variant-id') || '';
      if (sellingPlanInput) sellingPlanInput.value = isOneTime ? '' : (card.getAttribute('data-selling-plan') || '');
      if (quantityInput) {
        var q = parseInt(card.getAttribute('data-cart-quantity'), 10);
        quantityInput.value = (!isNaN(q) && q > 0) ? q : 1;
      }

      setPurchaseType(isOneTime ? 'onetime' : 'subscription');

      var atcForMode = isOneTime
        ? (card.getAttribute('data-onetime-atc-price') || card.getAttribute('data-atc-price'))
        : card.getAttribute('data-atc-price');
      if (atcPriceSlot) atcPriceSlot.textContent = atcForMode || '';
    }

    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    /* Apply the Liquid-selected default AFTER handlers are bound */
    var defaultCard = document.querySelector('.petlab2-pdp__qty-card--selected') || qtyCards[0];
    if (defaultCard) selectCard(defaultCard);


    /* ============ Subscribe / one-time mode ============
       The toggle under the cards flips a page-level mode instead of being a
       card of its own. Each plan card already carried data-sub-* and
       data-onetime-* values; this reads them and swaps what is displayed.
       Variant stays the same in both modes — only the selling plan differs,
       which selectCard() already handles. */
    var modeSwitch = document.querySelector('[data-mode-switch]');
    var planCards = document.querySelectorAll('.petlab2-pdp__qty-card--plan');

    function fillSlot(card, selector, value, hideTarget) {
      var el = card.querySelector(selector);
      if (!el) return;
      el.textContent = value || '';
      var target = hideTarget === 'parent' ? el.parentNode : el;
      if (target) target.hidden = !value;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function swapCards(one) {
      Array.prototype.forEach.call(planCards, function(card) {
        function val(name) { return card.getAttribute(name) || ''; }
        var pre = one ? 'data-onetime-' : 'data-sub-';

        fillSlot(card, '[data-slot="sale-price"]', val(pre + 'sale-price'));
        fillSlot(card, '[data-slot="compare-price"]', val(pre + 'compare-price'), 'parent');
        fillSlot(card, '[data-slot="meta"]', val(pre + 'meta'));
        fillSlot(card, '[data-badge-slot="discount"]', val(pre + 'discount-badge'));
        fillSlot(card, '[data-badge-slot="urgency"]', val(pre + 'urgency-badge'));
        fillSlot(card, '[data-slot="saving"]', val(pre + 'saving'));
        fillSlot(card, '[data-slot="price-suffix"]', val(pre + 'suffix'));

        /* the ribbon reserves space via a modifier class, so keep it in step */
        if (val(pre + 'urgency-badge')) {
          card.classList.add('petlab2-pdp__qty-card--ribboned');
        } else {
          card.classList.remove('petlab2-pdp__qty-card--ribboned');
        }

        card.setAttribute('data-purchase-mode', one ? 'onetime' : 'subscription');
      });
    }

    function reselect() {
      var current = document.querySelector('.petlab2-pdp__qty-card--plan.petlab2-pdp__qty-card--selected')
                 || planCards[0];
      if (current) selectCard(current);
    }

    function applyMode(mode, skipSelect) {
      var one = mode === 'onetime';

      /* Flip the wrapper first. The welcome kit collapses off this attribute, so
         starting it here lets the height change run alongside the price fade
         instead of waiting for it. */
      if (infoWrapper) {
        infoWrapper.setAttribute('data-purchase-type', one ? 'onetime' : 'subscription');
      }

      if (skipSelect || prefersReducedMotion()) {
        swapCards(one);
        if (!skipSelect) reselect();
        return;
      }

      /* fade the price column out, change the numbers while they cannot be seen,
         then fade back in — otherwise the figures visibly jump */
      Array.prototype.forEach.call(planCards, function(c) {
        c.classList.add('petlab2-pdp__qty-card--swapping');
      });
      window.setTimeout(function() {
        swapCards(one);
        reselect();
        Array.prototype.forEach.call(planCards, function(c) {
          c.classList.remove('petlab2-pdp__qty-card--swapping');
        });
      }, 150);
    }

    if (modeSwitch) {
      modeSwitch.addEventListener('click', function() {
        var wasSub = modeSwitch.getAttribute('aria-checked') === 'true';
        modeSwitch.setAttribute('aria-checked', wasSub ? 'false' : 'true');
        applyMode(wasSub ? 'onetime' : 'subscription');
      });
      /* normalise the rendered values without disturbing the default selection */
      applyMode(modeSwitch.getAttribute('aria-checked') === 'true' ? 'subscription' : 'onetime', true);
    }

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab2-product-form');
    var atcButton = document.getElementById('petlab2-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab2-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab2-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab2-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab2-atc-error');
    var variantInput = document.getElementById('petlab2-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        /* ============================================================
           REPLACED: Kaching bundle payload -> variant + Loop selling plan.

           Each supply length is now its own Shopify variant carrying its own
           Loop selling plan, and Loop applies the subscription discount. The
           Kaching bundle metadata and percentage price adjustment are gone,
           because leaving them in would discount the line twice.

           Gifts are plain line items, zeroed by the automatic Shopify
           discounts. Which gifts come along is driven by data-gift-count on
           the selected card, read against the kit tile order. A blank entry
           in that list is a display-only tile and adds nothing.

           Resulting payload matches the /cart/add permalinks exactly:
             main variant (qty 1, selling_plan) + the plan's gift variants.
           ============================================================ */

        /* ============================================================
           This is the ORIGINAL payload builder, restored verbatim.

           ONE change from the original, marked below: each supply length is
           now its own Shopify variant with its own Loop selling plan, so the
           variant and plan come from the selected card rather than from a
           single section-level product and plan, and the main line goes in at
           quantity 1 because the variant already encodes the supply.

           Everything else — the Kaching metadata, parent_id, the gift
           thresholds, the price adjustment, the ordering — is untouched.
           ============================================================ */

        var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
        if (!selectedCard) { showAtcError('Please choose an option first.'); return; }

        /* Tier: 1, 2 or 3. Still drives the Kaching bid and which gifts come
           along, exactly as before. It is no longer the cart quantity. */
        var lineQuantity = 1;
        var selectedQty = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10);
        if (!isNaN(selectedQty) && selectedQty > 0) lineQuantity = selectedQty;

        var purchaseType = infoWrapper ? infoWrapper.getAttribute('data-purchase-type') : 'subscription';

        /* >>> THE ONE CHANGE <<< variant and selling plan now come from the card */
        var variantId = selectedCard.getAttribute('data-variant-id') || (variantInput ? variantInput.value : '');
        var cardSellingPlan = selectedCard.getAttribute('data-selling-plan') || '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingDealVersion = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal-version') : '';
        /* CHANGED: the price adjustment differs per tier in Kaching's own payload,
           so it is read per tier rather than from one section-wide percentage. */
        var kachingPctByQty = {
          1: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-1') : '') || 0,
          2: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-2') : '') || 0,
          3: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-3') : '') || 0
        };
        var kachingSubPct = kachingPctByQty[lineQuantity] || kachingPctByQty[1];
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        /* CHANGED: was the single section-level plan, now the card's plan */
        var sellingPlanInt = parseInt(cardSellingPlan, 10);
        if (isNaN(sellingPlanInt)) sellingPlanInt = 0;

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var isSub = (purchaseType === 'subscription');
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, v: kachingDealVersion, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        var payload = { items: [] };

        /* Gifts first */
        if (isSub && ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (isSub && mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab2-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var kachingProductId = parseInt(infoWrapper ? infoWrapper.getAttribute('data-kaching-product-id') : '', 10);
        var mainKachingMeta = { deal: kachingDeal, main: true, v: kachingDealVersion, id: bundleInstanceId, bid: mainBid };
        /* Kaching's own widget includes pp (the product id) on the main line. Matching
           its payload shape gives the app the best chance of recognising the bundle. */
        if (!isNaN(kachingProductId) && kachingProductId) mainKachingMeta.pp = kachingProductId;
        if (isSub && sellingPlanInt) { mainKachingMeta.sellingPlan = { id: sellingPlanInt, priceAdjustment: { type: 'percentage', value: kachingSubPct } }; }
        /* CHANGED: quantity 1, not lineQuantity.
           Kaching's cart transform pulls ONE unit into a Shopify bundle with the
           gifts (the parent_relationship on the gift lines) and leaves the rest as
           a separate line — which is why a 3-tub add rendered as qty 2 + qty 1.
           Sending a single unit leaves nothing to split off, so the dissolver and
           its gifts stay as one group.
           Each variant is now priced as the whole supply, so quantity carries no
           pricing meaning: 1 Month $49.95, 2 Months $99.90, 3 Months $149.85.
           lineQuantity is still the tier (1/2/3) and still drives the Kaching bid
           and which gifts come along. */
        var mainItem = { id: variantId, quantity: 1, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        if (isSub && sellingPlanInt) mainItem.selling_plan = sellingPlanInt;
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          setAtcLoading(false);
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
          /* Surface the exact payload and Shopify's reply, so a failed add can be
             diagnosed from the console instead of guessed at. */
          if (window.console && console.error) {
            console.error('[K9 ATC] cart/add failed');
            console.error('[K9 ATC] payload sent:', JSON.stringify(payload, null, 2));
            console.error('[K9 ATC] shopify said:', err.responseData || err.message);
          }
        });
      });
    }
    /* ============ Product Info Accordion ============ */
    var accordionTriggers = document.querySelectorAll('[data-petlab2-accordion-trigger]');
    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var content = trigger.nextElementSibling;
        if (!content) return;
        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.classList.remove('petlab2-accordion--open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.classList.add('petlab2-accordion--open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector-pdp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab2-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp2-carousel-slides]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab2-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var currentSlide = 0;
      var progressFill = carousel.querySelector('[data-pdp2-carousel-progress-fill]');
      var thumbButtons = carousel.querySelectorAll('.petlab2-pdp__carousel-thumb');
      var thumbsContainer = carousel.querySelector('[data-pdp2-carousel-thumbs]');
      var thumbPrev = carousel.querySelector('[data-pdp2-thumb-prev]');
      var thumbNext = carousel.querySelector('[data-pdp2-thumb-next]');
      var desktopMq = window.matchMedia('(min-width: 768px)');

      /* Desktop: navigate main image via translateX */
      var thumbOffset = 0;
      var thumbsPerView = 4;

      function updateThumbView() {
        if (!thumbsContainer) return;
        var thumbEls = thumbsContainer.querySelectorAll('.petlab2-pdp__carousel-thumb');
        if (thumbEls.length === 0) return;
        var thumbWidth = thumbEls[0].offsetWidth + 6;
        thumbsContainer.scrollTo({ left: thumbOffset * thumbWidth, behavior: 'smooth' });
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentSlide = index;
        slidesContainer.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        thumbButtons.forEach(function(thumb, i) {
          thumb.classList.toggle('petlab2-pdp__carousel-thumb--active', i === index);
        });
        /* Keep active thumb in the visible window of 4 */
        if (index < thumbOffset) {
          thumbOffset = index;
          updateThumbView();
        } else if (index >= thumbOffset + thumbsPerView) {
          thumbOffset = index - thumbsPerView + 1;
          updateThumbView();
        }
      }

      /* Thumbnail click handlers */
      thumbButtons.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { goToSlide(i); });
      });

      /* Thumbnail strip arrow handlers — shift visible thumbnails + navigate main image */
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function() {
          if (thumbOffset > 0) {
            thumbOffset--;
            updateThumbView();
          }
          if (currentSlide > 0) goToSlide(currentSlide - 1);
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function() {
          if (thumbOffset < totalSlides - thumbsPerView) {
            thumbOffset++;
            updateThumbView();
          }
          if (currentSlide < totalSlides - 1) goToSlide(currentSlide + 1);
        });
      }

      /* Mobile: progress bar — smooth RAF loop */
      if (progressFill) {
        (function rafLoop() {
          if (!desktopMq.matches) {
            var sw = slidesContainer.scrollWidth;
            var cw = slidesContainer.clientWidth;
            if (sw > cw) {
              var p = (slidesContainer.scrollLeft + cw) / sw;
              progressFill.style.width = (Math.min(Math.max(p, 0), 1) * 100) + '%';
            }
          }
          requestAnimationFrame(rafLoop);
        })();
      }

      /* Handle resize between mobile ↔ desktop */
      function handleResize() {
        if (desktopMq.matches) {
          slidesContainer.scrollLeft = 0;
          goToSlide(currentSlide);
        } else {
          slidesContainer.style.transform = '';
        }
      }
      if (desktopMq.addEventListener) { desktopMq.addEventListener('change', handleResize); }
      else if (desktopMq.addListener) { desktopMq.addListener(handleResize); }

      /* Desktop: swipe on main image */
      var deskTouchStartX = 0;
      slidesContainer.addEventListener('touchstart', function(e) {
        if (desktopMq.matches) deskTouchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slidesContainer.addEventListener('touchend', function(e) {
        if (!desktopMq.matches) return;
        var diff = deskTouchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide(currentSlide + 1);
          else goToSlide(currentSlide - 1);
        }
      });

      /* Initial state */
      if (desktopMq.matches) { goToSlide(0); }
    });

    /* ============ REMOVED: size button handlers ============
       The dog-size selector no longer exists. The old
       sizeIndexToQuantity bridge and its auto-click are gone;
       the default plan is now selected directly (see below). */

    var infoWrapper = document.getElementById('petlab2-pdp-info');
    var sellingPlanInput = document.getElementById('petlab2-selling-plan');
    var quantityInput = document.getElementById('petlab2-line-quantity');
    var variantInputEl = document.getElementById('petlab2-variant-id');
    var atcPriceSlot = document.querySelector('[data-atc-price-slot]');

    /* Gift variants in tile order; a blank entry is a display-only tile */
    var kitVariants = (infoWrapper ? (infoWrapper.getAttribute('data-kit-variants') || '') : '')
      .split(',')
      .map(function(v) { return (v || '').trim(); });

    /* ============ Purchase type ============
       CHANGED: the selling plan is no longer a single section-level value, so
       this only flags the mode on the wrapper (the CSS uses it to hide
       subscription-only elements). selectCard() sets the plan itself. */
    function setPurchaseType(type) {
      if (!infoWrapper) return;
      infoWrapper.setAttribute('data-purchase-type', type);
    }

    /* ============ Plan card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab2-pdp__qty-card');

    function selectCard(card) {
      qtyCards.forEach(function(c) {
        c.classList.remove('petlab2-pdp__qty-card--selected');
        c.setAttribute('aria-checked', 'false');
        var r = c.querySelector('.petlab2-pdp__radio-outer');
        if (r) { r.classList.remove('petlab2-pdp__radio-outer--checked'); r.innerHTML = ''; }
      });
      card.classList.add('petlab2-pdp__qty-card--selected');
      card.setAttribute('aria-checked', 'true');
      var radio = card.querySelector('.petlab2-pdp__radio-outer');
      if (radio) { radio.classList.add('petlab2-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab2-pdp__radio-inner"></div>'; }

      var isOneTime = card.getAttribute('data-purchase-mode') === 'onetime';

      /* CHANGED: variant, selling plan and quantity all come from the card now.
         Each supply length is its own variant, so quantity is normally 1. */
      if (variantInputEl) variantInputEl.value = card.getAttribute('data-variant-id') || '';
      if (sellingPlanInput) sellingPlanInput.value = isOneTime ? '' : (card.getAttribute('data-selling-plan') || '');
      if (quantityInput) {
        var q = parseInt(card.getAttribute('data-cart-quantity'), 10);
        quantityInput.value = (!isNaN(q) && q > 0) ? q : 1;
      }

      setPurchaseType(isOneTime ? 'onetime' : 'subscription');

      if (atcPriceSlot) atcPriceSlot.textContent = card.getAttribute('data-atc-price') || '';
    }

    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    /* Apply the Liquid-selected default AFTER handlers are bound */
    var defaultCard = document.querySelector('.petlab2-pdp__qty-card--selected') || qtyCards[0];
    if (defaultCard) selectCard(defaultCard);

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab2-product-form');
    var atcButton = document.getElementById('petlab2-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab2-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab2-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab2-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab2-atc-error');
    var variantInput = document.getElementById('petlab2-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        /* ============================================================
           REPLACED: Kaching bundle payload -> variant + Loop selling plan.

           Each supply length is now its own Shopify variant carrying its own
           Loop selling plan, and Loop applies the subscription discount. The
           Kaching bundle metadata and percentage price adjustment are gone,
           because leaving them in would discount the line twice.

           Gifts are plain line items, zeroed by the automatic Shopify
           discounts. Which gifts come along is driven by data-gift-count on
           the selected card, read against the kit tile order. A blank entry
           in that list is a display-only tile and adds nothing.

           Resulting payload matches the /cart/add permalinks exactly:
             main variant (qty 1, selling_plan) + the plan's gift variants.
           ============================================================ */

        /* ============================================================
           This is the ORIGINAL payload builder, restored verbatim.

           ONE change from the original, marked below: each supply length is
           now its own Shopify variant with its own Loop selling plan, so the
           variant and plan come from the selected card rather than from a
           single section-level product and plan, and the main line goes in at
           quantity 1 because the variant already encodes the supply.

           Everything else — the Kaching metadata, parent_id, the gift
           thresholds, the price adjustment, the ordering — is untouched.
           ============================================================ */

        var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
        if (!selectedCard) { showAtcError('Please choose an option first.'); return; }

        /* Tier: 1, 2 or 3. Still drives the Kaching bid and which gifts come
           along, exactly as before. It is no longer the cart quantity. */
        var lineQuantity = 1;
        var selectedQty = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10);
        if (!isNaN(selectedQty) && selectedQty > 0) lineQuantity = selectedQty;

        var purchaseType = infoWrapper ? infoWrapper.getAttribute('data-purchase-type') : 'subscription';

        /* >>> THE ONE CHANGE <<< variant and selling plan now come from the card */
        var variantId = selectedCard.getAttribute('data-variant-id') || (variantInput ? variantInput.value : '');
        var cardSellingPlan = selectedCard.getAttribute('data-selling-plan') || '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingDealVersion = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal-version') : '';
        /* CHANGED: the price adjustment differs per tier in Kaching's own payload,
           so it is read per tier rather than from one section-wide percentage. */
        var kachingPctByQty = {
          1: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-1') : '') || 0,
          2: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-2') : '') || 0,
          3: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-3') : '') || 0
        };
        var kachingSubPct = kachingPctByQty[lineQuantity] || kachingPctByQty[1];
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        /* CHANGED: was the single section-level plan, now the card's plan */
        var sellingPlanInt = parseInt(cardSellingPlan, 10);
        if (isNaN(sellingPlanInt)) sellingPlanInt = 0;

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var isSub = (purchaseType === 'subscription');
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, v: kachingDealVersion, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        var payload = { items: [] };

        /* Gifts first */
        if (ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab2-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var kachingProductId = parseInt(infoWrapper ? infoWrapper.getAttribute('data-kaching-product-id') : '', 10);
        var mainKachingMeta = { deal: kachingDeal, main: true, v: kachingDealVersion, id: bundleInstanceId, bid: mainBid };
        /* Kaching's own widget includes pp (the product id) on the main line. Matching
           its payload shape gives the app the best chance of recognising the bundle. */
        if (!isNaN(kachingProductId) && kachingProductId) mainKachingMeta.pp = kachingProductId;
        if (isSub && sellingPlanInt) { mainKachingMeta.sellingPlan = { id: sellingPlanInt, priceAdjustment: { type: 'percentage', value: kachingSubPct } }; }
        /* CHANGED: quantity 1, not lineQuantity.
           Kaching's cart transform pulls ONE unit into a Shopify bundle with the
           gifts (the parent_relationship on the gift lines) and leaves the rest as
           a separate line — which is why a 3-tub add rendered as qty 2 + qty 1.
           Sending a single unit leaves nothing to split off, so the dissolver and
           its gifts stay as one group.
           Each variant is now priced as the whole supply, so quantity carries no
           pricing meaning: 1 Month $49.95, 2 Months $99.90, 3 Months $149.85.
           lineQuantity is still the tier (1/2/3) and still drives the Kaching bid
           and which gifts come along. */
        var mainItem = { id: variantId, quantity: 1, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        if (isSub && sellingPlanInt) mainItem.selling_plan = sellingPlanInt;
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          setAtcLoading(false);
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
          /* Surface the exact payload and Shopify's reply, so a failed add can be
             diagnosed from the console instead of guessed at. */
          if (window.console && console.error) {
            console.error('[K9 ATC] cart/add failed');
            console.error('[K9 ATC] payload sent:', JSON.stringify(payload, null, 2));
            console.error('[K9 ATC] shopify said:', err.responseData || err.message);
          }
        });
      });
    }
    /* ============ Product Info Accordion ============ */
    var accordionTriggers = document.querySelectorAll('[data-petlab2-accordion-trigger]');
    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var content = trigger.nextElementSibling;
        if (!content) return;
        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.classList.remove('petlab2-accordion--open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.classList.add('petlab2-accordion--open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp-carousel-slides]');
      var dotsContainer = carousel.querySelector('[data-pdp-carousel-dots]');
      var prevBtn = carousel.querySelector('[data-pdp-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-pdp-carousel-next]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;
      var currentPdpSlide = 0;
      function goToPdpSlide(index) {
        currentPdpSlide = index;
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.petlab-pdp__carousel-dot');
          dots.forEach(function(d, i) { d.classList.toggle('petlab-pdp__carousel-dot--active', i === index); });
        }
      }
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-pdp__carousel-dot' + (index === 0 ? ' petlab-pdp__carousel-dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToPdpSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide - 1 + totalSlides) % totalSlides); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide + 1) % totalSlides); });
    });

    /* ============================================================
       OFFER LOGIC — ported from the K9Clean product selector.

       Replaces the dog-size buttons, the subscribe/one-time toggle and
       the old 1/3/5 Kaching payload. Each supply length is now its own
       Shopify variant carrying its own Loop selling plan, so variant,
       plan and quantity all come off the selected card.

       Form ids are this page's (#petlab-variant-id, #petlab-selling-plan,
       #petlab-line-quantity, #petlab-product-form, #petlab-add-to-cart) so
       the markup around the offer is untouched. The card classes stay
       petlab2-* because that is what the ported offer markup renders.
       ============================================================ */

    var infoWrapper = document.getElementById('petlab-pdp-info');
    var sellingPlanInput = document.getElementById('petlab-selling-plan');
    var quantityInput = document.getElementById('petlab-line-quantity');
    var variantInputEl = document.getElementById('petlab-variant-id');
    var atcPriceSlot = document.querySelector('[data-atc-price-slot]');

    /* Gift variants in tile order; a blank entry is a display-only tile */
    var kitVariants = (infoWrapper ? (infoWrapper.getAttribute('data-kit-variants') || '') : '')
      .split(',')
      .map(function(v) { return (v || '').trim(); });

    /* ============ Purchase type ============
       CHANGED: the selling plan is no longer a single section-level value, so
       this only flags the mode on the wrapper (the CSS uses it to hide
       subscription-only elements). selectCard() sets the plan itself. */
    function setPurchaseType(type) {
      if (!infoWrapper) return;
      infoWrapper.setAttribute('data-purchase-type', type);
    }

    /* ============ Plan card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab2-pdp__qty-card');

    function selectCard(card) {
      qtyCards.forEach(function(c) {
        c.classList.remove('petlab2-pdp__qty-card--selected');
        c.setAttribute('aria-checked', 'false');
        var r = c.querySelector('.petlab2-pdp__radio-outer');
        if (r) { r.classList.remove('petlab2-pdp__radio-outer--checked'); r.innerHTML = ''; }
      });
      card.classList.add('petlab2-pdp__qty-card--selected');
      card.setAttribute('aria-checked', 'true');
      var radio = card.querySelector('.petlab2-pdp__radio-outer');
      if (radio) { radio.classList.add('petlab2-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab2-pdp__radio-inner"></div>'; }

      var isOneTime = card.getAttribute('data-purchase-mode') === 'onetime';

      /* CHANGED: variant, selling plan and quantity all come from the card now.
         Each supply length is its own variant, so quantity is normally 1. */
      if (variantInputEl) variantInputEl.value = card.getAttribute('data-variant-id') || '';
      if (sellingPlanInput) sellingPlanInput.value = isOneTime ? '' : (card.getAttribute('data-selling-plan') || '');
      if (quantityInput) {
        var q = parseInt(card.getAttribute('data-cart-quantity'), 10);
        quantityInput.value = (!isNaN(q) && q > 0) ? q : 1;
      }

      setPurchaseType(isOneTime ? 'onetime' : 'subscription');

      /* CHANGED: the button price follows the mode. One-time falls back to the
         subscription figure when a card has no one-time price of its own. */
      var atcForMode = isOneTime
        ? (card.getAttribute('data-onetime-atc-price') || card.getAttribute('data-atc-price'))
        : card.getAttribute('data-atc-price');
      if (atcPriceSlot) atcPriceSlot.textContent = atcForMode || '';
    }

    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    /* Apply the Liquid-selected default AFTER handlers are bound */
    var defaultCard = document.querySelector('.petlab2-pdp__qty-card--selected') || qtyCards[0];
    if (defaultCard) selectCard(defaultCard);

    /* ============ Subscribe / one-time toggle ============
       Every plan card carries both sets of figures as data-sub-* and
       data-onetime-* values; this reads them and swaps what is displayed.
       Variant stays the same in both modes — only the selling plan differs,
       which selectCard() already handles. */
    var modeSwitch = document.querySelector('[data-mode-switch]');
    var planCards = document.querySelectorAll('.petlab2-pdp__qty-card--plan');

    function fillSlot(card, selector, value, hideTarget) {
      var el = card.querySelector(selector);
      if (!el) return;
      el.textContent = value || '';
      var target = hideTarget === 'parent' ? el.parentNode : el;
      if (target) target.hidden = !value;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function swapCards(one) {
      Array.prototype.forEach.call(planCards, function(card) {
        function val(name) { return card.getAttribute(name) || ''; }
        var pre = one ? 'data-onetime-' : 'data-sub-';

        fillSlot(card, '[data-slot="sale-price"]', val(pre + 'sale-price'));
        fillSlot(card, '[data-slot="compare-price"]', val(pre + 'compare-price'), 'parent');
        fillSlot(card, '[data-slot="meta"]', val(pre + 'meta'));
        fillSlot(card, '[data-badge-slot="discount"]', val(pre + 'discount-badge'));
        fillSlot(card, '[data-badge-slot="urgency"]', val(pre + 'urgency-badge'));
        fillSlot(card, '[data-slot="saving"]', val(pre + 'saving'));
        fillSlot(card, '[data-slot="price-suffix"]', val(pre + 'suffix'));

        /* the ribbon reserves space via a modifier class, so keep it in step */
        if (val(pre + 'urgency-badge')) {
          card.classList.add('petlab2-pdp__qty-card--ribboned');
        } else {
          card.classList.remove('petlab2-pdp__qty-card--ribboned');
        }

        card.setAttribute('data-purchase-mode', one ? 'onetime' : 'subscription');
      });
    }

    function reselect() {
      var current = document.querySelector('.petlab2-pdp__qty-card--plan.petlab2-pdp__qty-card--selected')
                 || planCards[0];
      if (current) selectCard(current);
    }

    function applyMode(mode, skipSelect) {
      var one = mode === 'onetime';

      /* Flip the wrapper first. The welcome kit collapses off this attribute, so
         starting it here lets the height change run alongside the price fade
         instead of waiting for it. */
      if (infoWrapper) {
        infoWrapper.setAttribute('data-purchase-type', one ? 'onetime' : 'subscription');
      }

      if (skipSelect || prefersReducedMotion()) {
        swapCards(one);
        if (!skipSelect) reselect();
        return;
      }

      /* fade the price column out, change the numbers while they cannot be seen,
         then fade back in — otherwise the figures visibly jump */
      Array.prototype.forEach.call(planCards, function(c) {
        c.classList.add('petlab2-pdp__qty-card--swapping');
      });
      window.setTimeout(function() {
        swapCards(one);
        reselect();
        Array.prototype.forEach.call(planCards, function(c) {
          c.classList.remove('petlab2-pdp__qty-card--swapping');
        });
      }, 150);
    }

    if (modeSwitch) {
      modeSwitch.addEventListener('click', function() {
        var wasSub = modeSwitch.getAttribute('aria-checked') === 'true';
        modeSwitch.setAttribute('aria-checked', wasSub ? 'false' : 'true');
        applyMode(wasSub ? 'onetime' : 'subscription');
      });
      /* normalise the rendered values without disturbing the default selection */
      applyMode(modeSwitch.getAttribute('aria-checked') === 'true' ? 'subscription' : 'onetime', true);
    }

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab-product-form');
    var atcButton = document.getElementById('petlab-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab-atc-error');
    var variantInput = document.getElementById('petlab-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Redirecting...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        /* ============================================================
           REPLACED: Kaching bundle payload -> variant + Loop selling plan.

           Each supply length is now its own Shopify variant carrying its own
           Loop selling plan, and Loop applies the subscription discount. The
           Kaching bundle metadata and percentage price adjustment are gone,
           because leaving them in would discount the line twice.

           Gifts are plain line items, zeroed by the automatic Shopify
           discounts. Which gifts come along is driven by data-gift-count on
           the selected card, read against the kit tile order. A blank entry
           in that list is a display-only tile and adds nothing.

           Resulting payload matches the /cart/add permalinks exactly:
             main variant (qty 1, selling_plan) + the plan's gift variants.
           ============================================================ */

        /* ============================================================
           This is the ORIGINAL payload builder, restored verbatim.

           ONE change from the original, marked below: each supply length is
           now its own Shopify variant with its own Loop selling plan, so the
           variant and plan come from the selected card rather than from a
           single section-level product and plan, and the main line goes in at
           quantity 1 because the variant already encodes the supply.

           Everything else — the Kaching metadata, parent_id, the gift
           thresholds, the price adjustment, the ordering — is untouched.
           ============================================================ */

        var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
        if (!selectedCard) { showAtcError('Please choose an option first.'); return; }

        /* Tier: 1, 2 or 3. Still drives the Kaching bid and which gifts come
           along, exactly as before. It is no longer the cart quantity. */
        var lineQuantity = 1;
        var selectedQty = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10);
        if (!isNaN(selectedQty) && selectedQty > 0) lineQuantity = selectedQty;

        var purchaseType = infoWrapper ? infoWrapper.getAttribute('data-purchase-type') : 'subscription';

        /* >>> THE ONE CHANGE <<< variant and selling plan now come from the card */
        var variantId = selectedCard.getAttribute('data-variant-id') || (variantInput ? variantInput.value : '');
        var cardSellingPlan = selectedCard.getAttribute('data-selling-plan') || '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingDealVersion = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal-version') : '';
        /* CHANGED: the price adjustment differs per tier in Kaching's own payload,
           so it is read per tier rather than from one section-wide percentage. */
        var kachingPctByQty = {
          1: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-1') : '') || 0,
          2: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-2') : '') || 0,
          3: parseFloat(infoWrapper ? infoWrapper.getAttribute('data-kaching-pct-3') : '') || 0
        };
        var kachingSubPct = kachingPctByQty[lineQuantity] || kachingPctByQty[1];
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        /* CHANGED: was the single section-level plan, now the card's plan */
        var sellingPlanInt = parseInt(cardSellingPlan, 10);
        if (isNaN(sellingPlanInt)) sellingPlanInt = 0;

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var isSub = (purchaseType === 'subscription');
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, v: kachingDealVersion, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        var payload = { items: [] };

        /* Gifts first.

           CHANGED: both lines are gated on isSub. Under the new offer the gifts
           are a subscription-only benefit, so a one-time order adds no gift
           lines at any tier — the 3 tub Buy 2 Get 1 Free included. The tier
           still drives the Kaching bid and the welcome kit tiles, which are
           display only; this is the only place gift line items are built.

           To hand a gift back to one-time buyers, delete the `isSub && ` from
           that line. */
        if (isSub && ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (isSub && mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var kachingProductId = parseInt(infoWrapper ? infoWrapper.getAttribute('data-kaching-product-id') : '', 10);
        var mainKachingMeta = { deal: kachingDeal, main: true, v: kachingDealVersion, id: bundleInstanceId, bid: mainBid };
        /* Kaching's own widget includes pp (the product id) on the main line. Matching
           its payload shape gives the app the best chance of recognising the bundle. */
        if (!isNaN(kachingProductId) && kachingProductId) mainKachingMeta.pp = kachingProductId;
        if (isSub && sellingPlanInt) { mainKachingMeta.sellingPlan = { id: sellingPlanInt, priceAdjustment: { type: 'percentage', value: kachingSubPct } }; }
        /* CHANGED: quantity 1, not lineQuantity.
           Kaching's cart transform pulls ONE unit into a Shopify bundle with the
           gifts (the parent_relationship on the gift lines) and leaves the rest as
           a separate line — which is why a 3-tub add rendered as qty 2 + qty 1.
           Sending a single unit leaves nothing to split off, so the dissolver and
           its gifts stay as one group.
           Each variant is now priced as the whole supply, so quantity carries no
           pricing meaning: 1 Month $49.95, 2 Months $99.90, 3 Months $149.85.
           lineQuantity is still the tier (1/2/3) and still drives the Kaching bid
           and which gifts come along. */
        var mainItem = { id: variantId, quantity: 1, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        if (isSub && sellingPlanInt) mainItem.selling_plan = sellingPlanInt;
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          /* RESTORED: this page goes straight to checkout after a successful
             add, as it did before the offer swap. The spinner is deliberately
             left running so the button cannot be pressed twice while the
             browser navigates. */
          if (atcLabel) atcLabel.textContent = 'Redirecting...';
          window.location.assign('/checkout');
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
          /* Surface the exact payload and Shopify's reply, so a failed add can be
             diagnosed from the console instead of guessed at. */
          if (window.console && console.error) {
            console.error('[K9 ATC] cart/add failed');
            console.error('[K9 ATC] payload sent:', JSON.stringify(payload, null, 2));
            console.error('[K9 ATC] shopify said:', err.responseData || err.message);
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[id^="petlab-reviews-"]');

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-reviews-track]');
      var prevBtn = carousel.querySelector('[data-reviews-prev]');
      var nextBtn = carousel.querySelector('[data-reviews-next]');
      var dotsContainer = carousel.parentElement.querySelector('[data-reviews-dots]');
      if (!track) return;

      var slides = track.querySelectorAll('.petlab-reviews__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      function getSlidesPerView() {
        return window.innerWidth >= 1024 ? 2 : 1;
      }

      var currentIndex = 0;

      function totalPages() {
        var per = getSlidesPerView();
        return Math.max(1, totalSlides - per + 1);
      }

      function clampIndex(idx) {
        var max = totalPages() - 1;
        if (idx < 0) return max;
        if (idx > max) return 0;
        return idx;
      }

      function goToIndex(idx) {
        currentIndex = clampIndex(idx);
        var targetSlide = slides[currentIndex];
        if (!targetSlide) return;
        track.style.transform = 'translateX(-' + targetSlide.offsetLeft + 'px)';
        updateDots();
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var pages = totalPages();
        if (pages <= 1) return;
        for (var i = 0; i < pages; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-reviews__dot' + (index === currentIndex ? ' petlab-reviews__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToIndex(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }

      function updateDots() {
        if (!dotsContainer) return;
        var dots = dotsContainer.querySelectorAll('.petlab-reviews__dot');
        dots.forEach(function(d, i) {
          d.classList.toggle('petlab-reviews__dot--active', i === currentIndex);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() { goToIndex(currentIndex - 1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() { goToIndex(currentIndex + 1); });
      }

      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          currentIndex = clampIndex(currentIndex);
          buildDots();
          goToIndex(currentIndex);
        }, 150);
      });

      buildDots();
      goToIndex(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
